module.exports = __webpack_public_path__ + "img/trash.972d8b38.svg";